import WalletConnect from "./components/WalletConnect";
import NFTList from "./components/NFTList";
import ListNFTForm from "./components/ListNFTForm";
import { useAccount } from "wagmi";
import { useEffect, useState } from "react";
import { ethers } from "ethers";
import MarketplaceFees from "./components/MarketplaceFees";

function App() {
  const { address } = useAccount();
  const [signer, setSigner] = useState(null);

  useEffect(() => {
    const loadSigner = async () => {
      if (!address) return;
      const provider = new ethers.BrowserProvider(window.ethereum);
      const signer = await provider.getSigner();
      setSigner(signer);
    };

    loadSigner();
  }, [address]);

  return (
    <div className="App" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: '#f7f8fa' }}>
      <h1 style={{ margin: '32px 0 24px 0', fontWeight: 700, fontSize: '2.5rem', color: '#222' }}>NFT Marketplace</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 24, alignItems: 'center', width: '100%' }}>
        <div className="component-card">
          <WalletConnect />
        </div>
        {address && signer && (
          <div className="component-card">
            <ListNFTForm signer={signer} />
          </div>
        )}
        {address && signer && (
          <div className="component-card">
            <NFTList signer={signer} />
          </div>
        )}
        {address && (
          <div className="component-card">
            <MarketplaceFees signer={signer} />
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
